export default __webpack_public_path__ + "static/media/SEY.05efd200.svg";